
import * as React from 'react';
import { Typography, Grid, List } from '@material-ui/core';
import ListButtonLink from './parts/ListButtonLink';
interface OwnProps {
}

const MainMenuPage: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <div>
      <Typography variant="h6">メインメニュー</Typography>
      <Grid container spacing={16}>
        <Grid item xs={4} />
        <Grid item xs={4}>
          <List>
            <ListButtonLink
              to={'sitelist'}
              label="画像診断"
            />
          </List>
          <List>
            <ListButtonLink
              to={'subdiv/sitelist'}
              label="細分化画像診断"
            />
          </List>
          <List>
            <ListButtonLink
              to={'obsrec/sitelist'}
              label="観察記録"
            />
          </List>
        </Grid>
      </Grid>
    </div>
  );
}
export default MainMenuPage;




// WEBPACK FOOTER //
// ./src/components/MainMenuPage.tsx